// authApi.js
import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const GetLastIpdRefund = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/ipd-refunds/get-last-ipd-refund`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "IpdRefunds fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const StoreIpdRefund = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/ipd-refunds`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetIpdRefunds = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/ipd-refunds`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "IpdRefunds fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetIpdRefundById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/ipd-refunds/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateIpdRefund = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/ipd-refunds/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteIpdRefund = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/ipd/ipd-refunds/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};